export default "https://cdn-static.gokick.com/assets/b18addbf7a1bb69f1adff96c45455352533f108a/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";